import typeCheck from 'common/util/typeCheck';

import {
  DATA_TABLE_SOURCE_RENTER_FEED,
} from 'common/dataTableConstants';

import {
  SR_API_ACTION_APARTMENT_LOCATOR_MARK_SEEN_ACTIVTY,
} from 'api/actionTypes';

export default async function markSeenActivity({ state, apiClient }, { activityId }) {
  typeCheck('activityId::PositiveNumber', activityId);

  const dataTableItems = state.get(['dataTables', DATA_TABLE_SOURCE_RENTER_FEED, 'items']);
  if (Array.isArray(dataTableItems)) {
    state.set(
      ['dataTables', DATA_TABLE_SOURCE_RENTER_FEED, 'items'],
      dataTableItems.map((item) => {
        return item.id === activityId
          ? { ...item, seen: true }
          : item;
      })
    );
  }

  const unseenFeedActivityCount = state.get(['apartmentLocator', 'unseenFeedActivityCount']);

  if (unseenFeedActivityCount) {
    state.set(
      ['apartmentLocator', 'unseenFeedActivityCount'],
      Math.max(0, unseenFeedActivityCount - 1),
    );
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_MARK_SEEN_ACTIVTY,
    state: state,
    payload: {
      activityId: activityId,
    },
  });
}
